<template>
  <v-row dense>
    <v-col cols="12">
      <v-card
        tile
        color="primary"
        class="elevation-0 mb-2"
      >
        <v-card-title
          class="font-weight-medium grey--text pt-1 pb-2"
        >
          Invitados
        </v-card-title>
        <v-card-subtitle class="pb-2">
          Reporte invitaciones propiedad / invitado
        </v-card-subtitle>
      </v-card>
      <v-card
        tile
        color="grey lighten-3"
        class="elevation-0"
      >
        <v-container fluid>
          <v-row dense>
            <v-col cols="3" sm="2">
              <date-component
                v-model="form.date_entry_after"
                label="Fecha desde"
              ></date-component>
            </v-col>
            <v-col cols="3" sm="2">
              <date-component
                v-model="form.date_entry_before"
                label="Fecha hasta"
              ></date-component>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="3" sm="4">
              <v-text-field
              v-model="form.search"
              label="Buscar por propiedad / invitado"
              hide-details
              dense
              outlined
              append-icon="mdi-magnify"
            >
              <template v-if="form.search" v-slot:append>
                <v-icon
                  @click.prevent="crearFilters"
                  link
                >
                  mdi-close
                </v-icon>
              </template>
            </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="text-right">
              <vue-excel-xlsx
                :data="invitations"
                :columns="columns"
                :filename="'Export invitaciones'"
                :sheetname="'invitaciones'"
                >
                <v-btn
                    x-small
                    outlined
                    color="primary"
                    class="mx-2"
                  >
                    Descargar
                    <v-icon right dark>mdi-cloud-download</v-icon>
                  </v-btn>
              </vue-excel-xlsx>
            </v-col>
          </v-row>
        </v-container>
      </v-card>

      <v-card  v-if="allowDisplayData" class="elevation-0 mt-3" tile>
        <v-data-table
          :headers="headers"
          :items="invitations"
          class="elevation-0"
          :options.sync="options"
          :server-items-length="totalIntivations"
          :loading="loading"
        >
          <template v-slot:item.guest="{ item }">
            {{ item.guest }}
            <span v-if="item.total_companions">({{ item.total_companions }})</span>
          </template>

        <template v-slot:item.total_companions="{ item }">
           {{ item.total_companions }}
          </template>

          <template v-slot:item.property="{ item }">
            <template v-if="item.property">
              <span
                class="text-capitalize"
              >
                {{ item.property.toLowerCase() }}, {{ item.area.toLowerCase() }}
              </span>
            </template>
            <template v-else>
              <span>
              {{ item.venue.name }}
              </span>
              <br>
              <v-chip
                v-if="item.event.name"
                label
                small
                class="mb-1"
              >
                {{ item.event.name }}
              </v-chip>
            </template>
          </template>
          <template v-slot:item.area="{ item }">
            <span class="text-capitalize">{{ item.area.toLowerCase() }}</span>
          </template>
          <template v-slot:item.status="{ item }">
            <v-chip
              small
              label
              :color="getColor(item.status)"
              dark
              class="v-btn--block v-chip-status"
            >
              {{ item.status }}
            </v-chip>
          </template>
          <template v-slot:item.date_entry="{ item }">
            {{ item.date_entry|date }}
          </template>
          <template v-slot:item.date_out="{ item }">
            {{ item.date_out|date }}
          </template>
          <template v-slot:item.create_by="{ item }">
              {{ item.create_by }}
          </template>
        </v-data-table>
      </v-card>
      <v-alert v-else
          color="red"
          type="error"
      >
          Su usuario no tiene permiso para ver este reporte...
      </v-alert>

    </v-col>
  </v-row>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import types from '@/types';
import DateComponent from '@/components/DateComponent';
import moment from 'moment';
import _ from 'lodash';

export default {
  components: {
    DateComponent,
  },

  data() {
    return {
      form: {
        date_entry_after: '',
        date_entry_before: '',
        search: '',
      },
      options: {},
      headers: [
        { text: 'Invitado', value: 'guest' },
        { text: '# Acompañantes', value: 'total_companions' },
        { text: 'Propiedad', value: 'property' },
        { text: 'Estado', value: 'status' },
        { text: 'Llegada', value: 'date_entry', xlsFormat: 'dateFormat' },
        { text: 'Salida', value: 'date_out', xlsFormat: 'dateFormat' },
        { text: 'Creado por', value: 'create_by' },
      ],
      loading: true,
      invitationId: null,
      showCheckin: false,
      showCheckout: false,
      showDetailCheckout: false,
      autoUpdate: true,
      interval: null,
      allowDisplayData: true,
    };
  },

  computed: {
    ...mapState(
      `${types.INVITATION}`, [
        'areas',
        'invitationStatus',
        'invitations',
        'totalIntivations',
      ],
    ),
    limit() {
      return this.options.itemsPerPage === -1
        ? this.totalIntivations : this.options.itemsPerPage;
    },
    columns() {
      return this.headers.map((item) => ({
        label: item.text,
        field: item.value,
        dataFormat: this[item.xlsFormat] ? this[item.xlsFormat] : this.generalFormat,
      }));
    },
  },

  watch: {
    form: {
      handler() {
        const clearPage = true;
        this.debouncedGetInvitations(this.getOptions(clearPage));
      },
      deep: true,
    },
    options: {
      handler() {
        const clearPage = false;
        this.getInvitations(this.getOptions(clearPage));
      },
      deep: true,
    },
  },

  methods: {
    ...mapMutations({
      [types.SHOW_BUSY]: `${types.APP}/${types.SHOW_BUSY}`,
      [types.HIDE_BUSY]: `${types.APP}/${types.HIDE_BUSY}`,
    }),
    ...mapActions({
      [types.SETUP_BACKOFFICE_REPORT]: `${types.INVITATION}/${types.SETUP_BACKOFFICE}`,
      [types.GET_INVITATIONS_REPORT]: `${types.INVITATION}/${types.GET_INVITATIONS_REPORT}`,
    }),
    getOptions(clearPage) {
      const params = {
        area: this.form.area,
        status: this.form.status,
        date_entry_after: this.form.date_entry_after,
        date_entry_before: this.form.date_entry_before,
        search: this.form.search,
      };
      if (clearPage) {
        delete params.page;
      }
      return params;
    },
    getTypeColor(type) {
      const colors = {
        'Family/Friends': 'light-blue darken-3',
        'Friends and Family': 'light-blue darken-3',
        Supplier: 'warning',
      };
      return colors[type];
    },
    getColor(status) {
      const colors = {
        Pending: 'success',
        'In House': 'warning lighten-1',
        'Check Out': 'error lighten-1',
        Cancelled: 'grey',
        'Overdue In House': 'error darken-1',
      };
      return colors[status];
    },
    generalFormat(value) {
      return value;
    },
    invitedName(value) {
      return value.invitated.name;
    },
    dateFormat(value) {
      return moment(value).format('DD-MMM-YYYY');
    },
    hourFormat(value) {
      return moment(value).format('HH:mm');
    },
    floatFormat(value) {
      return parseFloat(value) ? parseFloat(value) : value;
    },
    getAction(status) {
      const actions = {
        Pending: 'Check-in',
        'In House': 'Check-out',
        'Check Out': 'Ver',
        Cancelled: 'Ver',
        'Overdue In House': 'Check-out',
      };
      return actions[status];
    },
    getInvitations(params) {
      this.loading = true;
      this[types.GET_INVITATIONS_REPORT](params)
        .then(() => {
          this.loading = false;
        })
        .catch((error) => {
          if (error.response.status === 403) {
            this.allowDisplayData = false;
          }
        })
        .finally(() => {
          this[types.HIDE_BUSY]();
          this.loading = false;
        });
    },
    dispatchAction(status, invitationId) {
      switch (status) {
        case 'Pending':
          this.invitationId = invitationId;
          this.showCheckin = true;
          break;
        case 'In House':
        case 'Overdue In House':
          this.invitationId = invitationId;
          this.showCheckout = true;
          break;
        case 'Check Out':
          this.invitationId = invitationId;
          this.showDetailCheckout = true;
          break;
        default:
          this.$router.push({ name: 'Todo' });
          break;
      }
    },
    crearFilters() {
      this.form.search = '';
      this.form.date_entry = '';
    },
  },

  mounted() {
    this[types.SHOW_BUSY]('Cargando...');
    this[types.SETUP_BACKOFFICE_REPORT]();
    this.debouncedGetInvitations = _.debounce(this.getInvitations, 1000);
  },

  created() {
    const today = new Date();
    const yesterday = new Date(today.setDate(today.getDate() - 1));
    // eslint-disable-next-line no-underscore-dangle
    this.form.date_entry_after = yesterday.toISOString().substr(0, 10);
    this.form.date_entry_before = new Date().toISOString().substr(0, 10);
  },

  destroyed() {
    clearInterval(this.interval);
  },
};
</script>

<style>
.v-data-table__wrapper tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, .05);
}
.v-chip-status {
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/views/ReportInvitationsProperty.vue